import { useState, useEffect } from 'react';
import api from '../../schedulerApi';

const useHttpGetModes = () => {
    const [data, setData] = useState([]);
    const [isReady, setIsReady] = useState(false);

    const fetchModes = async () => {
        try {
            const modes = await api.get_operational_modes();
            setData(modes);
        } catch (error) {
            console.error('Unexpected error occurred while fetching operational modes: ', error);
        } finally {
            setIsReady(true);
        }
    };

    useEffect(() => {
        fetchModes();
    }, []);

    return { data, isReady, refetch: fetchModes };
};

export default useHttpGetModes;
